import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "icon"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconMore } from '../Icon/index';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden';
import { DropdownIconMixin } from '../../mixins/components/DropdownIconMixin';
export var StyledDropdownIcon = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledDropdownIcon",
  componentId: "c11n-8-64-0__sc-7y5ig8-0"
})(["", ""], DropdownIconMixin);
/**
 * The default variant for [`DropdownPopper`](#/Dialog%20components?id=dropdownpopper).
 *
 * @since 7.28.0
 */

var DropdownIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledDropdownIcon, _extends({}, rest, {
    ref: ref
  }), icon, children);
});
DropdownIcon.displayName = 'DropdownIcon';
DropdownIcon.propTypes = {
  /**
   * You can use the children prop to provide a
   * [`VisuallyHidden`](#/More%20components?id=visuallyhidden) label.
   */
  children: PropTypes.node,

  /**
   * The [`Icon`](#/More%20components?id=icon) used as a trigger.
   */
  icon: PropTypes.node
};
DropdownIcon.defaultProps = {
  children: /*#__PURE__*/React.createElement(VisuallyHidden, null, "Show more"),
  icon: /*#__PURE__*/React.createElement(IconMore, null)
};
/** @component */

export default DropdownIcon;